var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"atom-btn",class:[("atom-btn--" + _vm.type)],attrs:{"type":_vm.nativeType}},_vm.$listeners),[(_vm.icon)?_c('a-icon',{staticClass:"atom-btn__icon",attrs:{"name":_vm.icon,"size":"16"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dddc6f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/Button/Button.vue
// module id = 235
// module chunks = 0